"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SwitchStatusBatch", {
  enumerable: true,
  get: function get() {
    return _SwitchStatusBatch.SwitchStatusBatch;
  }
});

var _SwitchStatusBatch = require("./SwitchStatusBatch.connect");